import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import arrowIcon from '@assets/images/arrow_up-icon.svg'
import trashIcon from '@assets/images/trash-icon.svg'

import { SwitchButton } from '@components/SwitchButton'

import {
  ArrowImg,
  ButtonArrowContainer,
  ButtonContainer,
  CardContainer,
  CardContent,
  CardHeaderContainer,
  CardHeaderTitle,
  Label,
  SubmitButton,
  SwitchContainer,
  SwitchLabel,
} from './FormFieldConfigValidate.styled'

export type FormFieldConfigValidateProps = {
  allowAdminEdit: boolean
  onChange: (allowAdminEdit: boolean) => void
  onDelete: () => void
}

export const FormFieldConfigValidate: React.FC<FormFieldConfigValidateProps> = ({
  allowAdminEdit,
  onChange,
  onDelete,
}: FormFieldConfigValidateProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(true)

  return (
    <CardContainer>
      <CardHeaderContainer>
        <ButtonArrowContainer
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            setOpen(!open)
          }}
        >
          <ArrowImg open={open} src={arrowIcon} />
        </ButtonArrowContainer>
        <CardHeaderTitle>{t('modules_project-form-models_components_FormFieldConfigValidate_title')}</CardHeaderTitle>

        <ButtonContainer
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            onDelete()
          }}
        >
          <img src={trashIcon} />
        </ButtonContainer>
      </CardHeaderContainer>

      {open && (
        <CardContent>
          <SubmitButton disabled>
            {t('modules_project-form-models_components_FormFieldConfigValidate_button_label')}
          </SubmitButton>
          <Label>{t('modules_project-form-models_components_FormFieldConfigValidate_label')}</Label>

          <SwitchContainer>
            <SwitchButton selected={allowAdminEdit} onClick={() => onChange(!allowAdminEdit)} />
            <SwitchLabel>
              {t('modules_project-form-models_components_FormFieldConfigValidate_switch_label')}
            </SwitchLabel>
          </SwitchContainer>
        </CardContent>
      )}
    </CardContainer>
  )
}
